import { useQuery } from '@pinia/colada';

import codeboxService from '../services/codebox.service';

export function getCodeboxIntegrationQueryKey() {
  return ['codeboxes', 'integration'];
}

export function getCodeboxesQueryKey() {
  return ['codeboxes'];
}

export function useCodeboxIntegrationQuery() {
  return useQuery({
    key: getCodeboxIntegrationQueryKey,
    query: async () => {
      const { data } = await codeboxService.getIntegrationStatus();
      return data;
    },
  });
}

export function useCodeboxesQuery(enabled: () => boolean) {
  return useQuery({
    key: getCodeboxesQueryKey,
    enabled,
    query: async () => {
      const { data } = await codeboxService.getAll();
      return data;
    },
  });
}

export function getCodeboxHistoryQueryKey(codeboxId: string) {
  return ['codeboxes', codeboxId, 'history'];
}

export function useCodeboxHistoryQuery(codeboxId: () => string | null) {
  return useQuery({
    key: () => getCodeboxHistoryQueryKey(codeboxId() ?? ''),
    enabled: () => Boolean(codeboxId()),
    query: async () => {
      const { data } = await codeboxService.getHistory(codeboxId() as string);
      return data;
    },
  });
}

export function getCodeboxActivityQueryKey() {
  return ['codeboxes', 'activity'];
}

export function useCodeboxActivityQuery(enabled: () => boolean) {
  return useQuery({
    key: getCodeboxActivityQueryKey,
    enabled,
    query: async () => {
      const { data } = await codeboxService.getActivity();
      return data;
    },
  });
}
